export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 68 68" fill="none">
            <path
                opacity="0.5"
                d="M67.9999 34.32C67.9999 52.9208 52.9208 67.9999 34.32 67.9999C15.7192 67.9999 0.640137 52.9208 0.640137 34.32C0.640137 15.7192 15.7192 0.640137 34.32 0.640137C52.9208 0.640137 67.9999 15.7192 67.9999 34.32Z"
                fill="url(#paint0_radial_593_6105)"
            />
            <path
                d="M58.0733 34.6362C57.3045 34.692 56.5542 34.7726 55.8102 34.8967C55.8102 34.8967 55.7978 34.8967 55.7916 34.8967C50.5896 35.7337 45.9208 38.1704 42.306 41.6797C42.2192 41.7603 42.1262 41.8533 42.0394 41.9401C37.879 46.1005 35.1695 51.718 34.7293 57.9678C34.2829 51.7118 31.5795 46.1005 27.413 41.9401C23.2526 37.7798 17.6351 35.0702 11.3853 34.63C17.6413 34.1836 23.2526 31.4803 27.413 27.3137C29.8311 24.8956 31.7655 21.9815 33.0366 18.7387C33.9604 16.4074 34.5433 13.9025 34.7231 11.286C35.5973 23.7982 45.555 33.7496 58.0609 34.63L58.0733 34.6362Z"
                fill="url(#paint1_radial_593_6105)"
            />
            <path
                style={{ mixBlendMode: 'multiply' }}
                opacity="0.3"
                d="M34.7354 34.6362V57.974C34.2889 51.7179 31.5856 46.1067 27.419 41.9463C23.2587 37.7859 17.6412 35.0764 11.3914 34.6362H34.7354Z"
                fill="url(#paint2_radial_593_6105)"
            />
            <path
                style={{ mixBlendMode: 'multiply' }}
                opacity="0.5"
                d="M58.0732 34.6362C58.0732 34.7664 57.2051 34.8532 55.8101 34.8966C55.8101 34.8966 55.7977 34.8966 55.7915 34.8966C49.9198 35.0888 34.7354 34.63 34.7354 34.63V11.286C35.6096 23.7981 45.5672 33.7496 58.0732 34.63V34.6362Z"
                fill="url(#paint3_radial_593_6105)"
            />
            <path
                d="M26.4089 47.9234C26.136 47.942 25.8694 47.973 25.6028 48.0164C23.7489 48.314 22.0811 49.1821 20.7914 50.4345C20.7604 50.4655 20.7294 50.4965 20.6984 50.5275C19.2165 52.0094 18.2493 54.0121 18.0943 56.2442C17.9331 54.0121 16.972 52.0094 15.484 50.5275C14.0021 49.0457 11.9932 48.0784 9.76733 47.9172C11.9994 47.7622 14.0021 46.7949 15.484 45.3069C16.3458 44.445 17.0341 43.4034 17.4929 42.2439C17.8215 41.4131 18.0323 40.5203 18.0943 39.584C18.4043 44.0482 21.9571 47.5948 26.4213 47.911L26.4089 47.9234Z"
                fill="url(#paint4_radial_593_6105)"
            />
            <path
                style={{ mixBlendMode: 'multiply' }}
                opacity="0.3"
                d="M18.0814 47.9234V56.2503C17.9201 54.0183 16.9591 52.0156 15.471 50.5337C13.9892 49.0518 11.9803 48.0846 9.75439 47.9234H18.0814Z"
                fill="url(#paint5_radial_593_6105)"
            />
            <path
                style={{ mixBlendMode: 'multiply' }}
                opacity="0.5"
                d="M26.4084 47.9234C26.4084 47.973 26.0984 47.9978 25.6024 48.0164C23.5067 48.0846 18.0876 47.9234 18.0876 47.9234V39.5964C18.3977 44.0606 21.9504 47.6072 26.4146 47.9234H26.4084Z"
                fill="url(#paint6_radial_593_6105)"
            />
            <path
                d="M55.8773 21.4225C55.7719 21.4287 55.6727 21.4411 55.5673 21.4597C54.8605 21.5713 54.2218 21.9061 53.7258 22.3835C53.7134 22.3959 53.701 22.4083 53.6886 22.4207C53.1182 22.985 52.7524 23.7538 52.6904 24.6094C52.6284 23.7538 52.2625 22.9912 51.6921 22.4207C51.1279 21.8503 50.3591 21.4845 49.5034 21.4225C50.3591 21.3605 51.1217 20.9947 51.6921 20.4243C52.0207 20.0956 52.2874 19.6988 52.461 19.2524C52.585 18.9362 52.6656 18.5952 52.6904 18.2356C52.8082 19.9406 54.166 21.2985 55.8711 21.4163L55.8773 21.4225Z"
                fill="url(#paint7_radial_593_6105)"
            />
            <path
                style={{ mixBlendMode: 'multiply' }}
                opacity="0.3"
                d="M52.6904 21.4225V24.6032C52.6284 23.7476 52.2625 22.985 51.6921 22.4145C51.1279 21.8441 50.3591 21.4783 49.5034 21.4163H52.6904V21.4225Z"
                fill="url(#paint8_radial_593_6105)"
            />
            <path
                style={{ mixBlendMode: 'screen' }}
                opacity="0.5"
                d="M55.8773 21.4225C55.8773 21.4225 55.7595 21.4535 55.5672 21.4597C54.7674 21.4845 52.6965 21.4225 52.6965 21.4225V18.2418C52.8143 19.9468 54.1722 21.3047 55.8773 21.4225Z"
                fill="url(#paint9_radial_593_6105)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(34.32 34.32) scale(33.6799 33.6799)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.11" stopColor="#FEB837" stopOpacity="0.8" />
                    <stop offset="0.24" stopColor="#FEB837" stopOpacity="0.59" />
                    <stop offset="0.37" stopColor="#FEB837" stopOpacity="0.41" />
                    <stop offset="0.5" stopColor="#FEB837" stopOpacity="0.26" />
                    <stop offset="0.63" stopColor="#FEB837" stopOpacity="0.15" />
                    <stop offset="0.75" stopColor="#FEB837" stopOpacity="0.07" />
                    <stop offset="0.88" stopColor="#FEB837" stopOpacity="0.02" />
                    <stop offset="1" stopColor="#FEB837" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(34.7355 34.63) scale(23.344 23.344)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(23.0665 46.3051) scale(11.6689 11.6689)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint3_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(46.4043 23.1223) scale(11.7495 11.7495)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint4_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18.0819 47.9234) scale(8.32696 8.32696)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint5_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(13.921 52.0838) scale(4.16038 4.16039)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint6_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.248 43.8188) scale(4.19138 4.19139)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint7_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(52.6904 21.4225) scale(3.18074)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint8_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(51.1031 23.016) scale(1.59347)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
                <radialGradient
                    id="paint9_radial_593_6105"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(54.2838 19.8538) scale(1.59966 1.59967)"
                >
                    <stop stopColor="#FEB837" />
                    <stop offset="0.6" stopColor="#FEBA37" />
                    <stop offset="0.88" stopColor="#FEC137" />
                    <stop offset="1" stopColor="#FEC837" />
                </radialGradient>
            </defs>
        </svg>
    );
}
